import React, { Component } from "react";
import StepZilla from "react-stepzilla";
import "../App.css";
import "react-stepzilla/src/css/main.css";

import RoutingLiberty from "./steps/RoutingLiberty.jsx";
import Environment from "./steps/Environment.jsx";
import SubBU from "./steps/SubBU.jsx";
import LibertyEnv from "./steps/LibertyEnv.jsx";
import ProductName from "./steps/ProductName.jsx";
import SummaryLiberty from "./steps/SummaryLiberty.jsx";
import TargetHost from "./steps/TargetHost.jsx";

class CreateNewProxyLibertyHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      virtualPath: "/retirement/v1/sample",
      targetPath: "/retirement/v1/sample",
      targetHost: "https://api100.test.principal.com",
      environment: "internal",
      buildEnvironment: [],
      //used for naming the prefix
      subBU: "WSRS",
      //used to determine product name + the owning AD group, see comment below
      productName: "",
      //this is only used if a) the Product does not exist, or b) the Product currently has no owning AD group assigned.
      adGroup: "",
      gitURL: "",
      isNewProduct: false
    };
  }

  getStore = () => {
    return this.state;
  };

  updateStore = (update) => {
    this.setState(update);
  };

  render() {
    const createNewProxyLibertySteps = [
      {
        name: "Deployment Environment",
        component: (
          <Environment
            getStore={this.getStore}
            updateStore={this.updateStore}
          />
        ),
      },
      {
        name: "Build Environment",
        component: (
          <LibertyEnv getStore={this.getStore} updateStore={this.updateStore} />
        ),
      },
      {
        name: "Target Host",
        component: (
          <TargetHost getStore={this.getStore} updateStore={this.updateStore} />
        ),
      },
      {
        name: "Routing",
        component: (
          <RoutingLiberty
            getStore={this.getStore}
            updateStore={this.updateStore}
          />
        ),
      },
      {
        name: "SubBU",
        component: (
          <SubBU getStore={this.getStore} updateStore={this.updateStore} />
        ),
      },
      {
        name: "Product Name",
        component: (
          <ProductName
            getStore={this.getStore}
            updateStore={this.updateStore}
          />
        ),
      },
      {
        name: "Summary",
        component: <SummaryLiberty getStore={this.getStore} />,
      },
    ];
    return (
      <div className="container">
        <h1>Create New Proxy for Liberty</h1>
        <hr />
        <div className="step-progress">
          <StepZilla
            nextButtonCls="btn btn-next btn-primary util-margin-top-50"
            backButtonCls="btn btn-prev btn-link util-margin-top-50"
            steps={createNewProxyLibertySteps}
          />
        </div>
      </div>
    );
  }
}

export default CreateNewProxyLibertyHome;
